export default function cookieBannerEn() {
  return window ? window.cookieBannerEn : '';
}
